const containsChinese = require('contains-chinese');
const wordsPerPage = 30000;

export const introText = `RainbowEdit is a tool for studying anything that's hard to read, whether it's a new language, poetry, or simply long words.

- "edit text" mode lets you edit the text itself
- "edit color" mode lets you edit the color of words
- the word lists you've generated are in the top right hand menu`;

export const upload = file => {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.onload = event => {
      // split each page on demand into newlines
      resolve(event.target.result);
    };
    reader.readAsText(file);
  });
};

export const breakIdentifier = 'breakIdentifier';
export const tabIdentifier = 'tabIdentifier';

// export const regex = /'|[^" \.,:!?()\[\]]+[A-Za-z0-9а-яА-Я]|[^ ]|[^\"]|./gim;
function textToArray(text, spaceBool = false) {

  var regexp = /\\t|\\n|\\"|((http|https|ftp|ftps)\:\/\/[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,3}(\/[^" <>\\]*)?)|[^" \.,:;«»!?&<>(){}\-\+\[\]\\/]+|\/{1,}|[A-Za-z0-9а-яА-Я\u00c0-\u00ff]+|[^ \"]|./gim;
  var newString = JSON.stringify(text);
  var result = newString.match(regexp);

  for (let i = 0; i < result.length; i++) {
    if (~result[i].indexOf("'") && result[i].length > 1) {

      if (~result[i][0].indexOf("'") && ~result[i][result[i].length - 1].indexOf("'")) {
        result[i] = result[i].slice(1, -1);
        result.splice(i, 1, "'", result[i], "'");
      } else if (~result[i][0].indexOf("'")) {
        result[i] = result[i].slice(1);
        result.splice(i, 1, "'", result[i]);
      } else if (~result[i][result[i].length - 1].indexOf("'")) {
        result[i] = result[i].slice(0, -1);
        result.splice(i, 1, result[i], "'");
      }

    }
  }

  result.splice(0, 1);
  result.splice(result.length - 1, 1);
  var count = 0;

  result = result.reduce((prev, item, index, arr) => {

    if (/^'|"$/gim.test(item)) {

      if (count == 0) {

        var pieceOfArray = [...arr];
        pieceOfArray = pieceOfArray.slice(index);
        var nearestСharIndex = pieceOfArray.indexOf(item, 1);
        count = nearestСharIndex;
        pieceOfArray = pieceOfArray.slice(0, nearestСharIndex);
        var prevElem = prev.slice(0, index);

        return [...prevElem, pieceOfArray.join('')+pieceOfArray[0]];

      } else {

        if (count != 0) {
          count--;
          return [...prev];
        } else {
          return [...prev, item];
        }

      }

    } else {

      if (count != 0) {
        count--;
        return [...prev];
      } else {
        return [...prev, item];
      }

    }

  }, []);

  if (spaceBool) {
    return result;
  } else {
    return result.filter((item) => item != ' ');
  }

}


export const chineseTextToArray = async text => {
  return new Promise((resolve, reject) => {
    if (window.call_jieba_cut && containsChinese(text)) {
      window.call_jieba_cut(text, function(result) {
        resolve(result);
      });
    } else {
      console.log(textToArray(text, true));
      resolve(textToArray(text, true));
    }
  });
};

export const paginate = (text, page) =>
  text.slice(page * wordsPerPage, (page + 1) * wordsPerPage);

export const totalPages = text => Math.ceil(text.length / wordsPerPage);

export const formatText = (wordList, color) => {
  let words = [];
  for (const word in wordList) {
    if (wordList[word] === color) {
      words.push(word.toLowerCase());
    }
  }
  return words.filter(word => word.replace(' ', '')).join(' ');
};

export const isCommentsOrStrings = word => word === '// comments' || word === "'strings'"
export const isComments = word => word === '// comments'
export const isStrings = word => word === "'strings'"

// style utils
export const normaliseStyle = style => {
    return {
      c: style.c,
      b: style.b,
      u: style.u,
      i: style.i,
      bg: style.bg
    }
  }

export const getWordsWithStyle = (wordList, style) => {
  const words = []
  Object.keys(wordList) 
    .forEach((word) => {
    if (isCommentsOrStrings(word)) {
      return
    }
    if (JSON.stringify(normaliseStyle(wordList[word])) === JSON.stringify(normaliseStyle(style))) {
      if (word.trim()) {
        if (wordList[word].namedStyle) {
          words.unshift(word)
        } else {
          words.push(word)
        }
        
      }
    }
  })
  return words
}
export const filterWordListByUniqueStyle = (wordList) => {
  const styles = []
  const newWordList = {}
  Object.keys(wordList) 
    .forEach((word) => {
      if (isCommentsOrStrings(word)) {
        return
      }
    const style = wordList[word]

    if (!styles.includes(JSON.stringify(normaliseStyle(style)))) {
      styles.push(JSON.stringify(normaliseStyle(style)))
      if (word.trim()) {
        newWordList[word] = wordList[word]
      }
    }
    if (style.namedStyle) {
      // if the style has already been given, overwrite the name
      const alreadyAddedWords = getWordsWithStyle(wordList, normaliseStyle(style))
      if (alreadyAddedWords.length) {
        for (var i = 0; i < alreadyAddedWords.length; i++) {
          delete newWordList[alreadyAddedWords[i]]
        }
        if (word.trim()) {
          newWordList[word] = wordList[word]
        }
      }
    }

  })
  return newWordList
}

export const getPropertiesUsed = (wordList, prop) => {
  const colors = []
  for (const [ key, value ] of Object.entries(wordList)) {
    if (!colors.includes(value[prop])) {
      colors.push(value[prop])
    }
  }
  return colors
}


// colour utils
export const palette = [
  // row 1
  '#BFBFBF',
  '#ffe9a3',
  '#ffad77',
  '#ff9295',
  '#ee9cff',
  '#90ceff',
  '#90f9ff',
  '#c0ffb6',
  // row 2
  '#8C8C8C',
  '#ffcc34',
  '#ff8d44',
  '#ff5156',
  '#d06aec',
  '#4dacff',
  '#00cfdb',
  '#7aed62',
  // row 3
  '#666',
  '#d79f00',
  '#f85f00',
  '#da1f23',
  '#b122d6',
  '#008eff',
  '#00a0a8',
  '#18b100',
  // row 4
  '#4D4D4D',
  '#906e00',
  '#a65215',
  '#9d2b31',
  '#7e309b',
  '#25679b',
  '#1a6872',
  '#23731e',
  // row 5
  '#141414',
  '#FFF'
];

export const invertPalette = (palette) => {
  const inverted = []
  for (var i = 0; i < 8; i++) {
    const colors = []
    for (var j = 0; j < 4; j++) {
      const index = i + (j * 8)
      colors.push(palette[index])
    }
    inverted.push(colors)
  }
  return inverted.reduce((a, b) => a.concat(b))
}

